import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { AudiostreamingComponent } from '../adminpages/audiostreaming/audiostreaming.component';

@Injectable({ providedIn: 'root' })
export class PreventRecordingDeactivateGuard implements CanDeactivate<AudiostreamingComponent> {
  canDeactivate(
    component: AudiostreamingComponent
  ): Observable<boolean> | Promise<boolean> | boolean {
    try {
      if (component && (component.isRecording || component.isStartingRecording || component.isPaused)) {
        // Use the component's notification helper to show a jqxNotification
        if (typeof component.sendNotification === 'function') {
          //component.sendNotification('Recording in progress — stop recording before leaving this page.', 'warning');
        }
        return false;
      }
    } catch (e) {
      // on error, default to allowing navigation
      return true;
    }
    return true;
  }
}
